import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { StationComponent } from './component/station.component';
import { StationDetailsComponent } from './component/station-details/station-details.component';
import { ApplicationClientCommonModule } from "@sdbn/appclient";
import { CommonTranslationModule, CommonUIModule, CommonLayoutModule } from "@sdbn/common";

@NgModule({
    declarations: [
        StationComponent,
        StationDetailsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CommonTranslationModule,
        MaterialModule,
        SharedModule,
        CommonUIModule,
        CommonLayoutModule,
        ApplicationClientCommonModule
    ]
})
export class StationModule { }

